/* eslint-disable no-unused-vars */
import React, { FC } from 'react';
import { ListGroup } from 'react-bootstrap';
import useReorder from '../../../hooks/useReorder/useReorder';
import { SortableListItem } from '../../atoms';
import {
  ListItem,
  SubListItem,
} from '../../atoms/SortableListItem/SortableListItem';
interface SortableListProps {
  listItems: ListItem[];
  setListItems: (items: ListItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  handleDelete: (id: string) => void;
  handleEdit: (id: string) => void;
}

const SortableList: FC<SortableListProps> = ({
  listItems,
  setListItems,
  changeOrderEnabled,
  handleDelete,
  handleEdit,
}) => {
  const [litems, moveItem] = useReorder<ListItem>(
    listItems,
    setListItems,
    false
  );

  const onSubListItemsChangeHandler = (
    id: string,
    items: SubListItem[],
    from: number,
    to: number
  ) => {
    const temp = [...litems];
    const index = temp.findIndex((item) => {
      if (item.id === id) {
        return true;
      }
      return false;
    });
    if (index !== -1) {
      temp[index].subListItems = items;
      setListItems(temp, from, to);
    }
  };

  return (
    <>
      <ListGroup>
        {litems.length === 0 && <p>Nothing to show.</p>}
        {litems.length > 0 &&
          litems.map((item, index) => {
            return (
              <SortableListItem
                key={item.id}
                id={item.id}
                listItems={litems}
                listItemsLength={litems.length}
                listItemIndex={index}
                moveListItem={moveItem}
                changeOrderEnabled={changeOrderEnabled}
                listItem={item}
                onSubListItemsChangeHandler={onSubListItemsChangeHandler}
                handleDelete={handleDelete}
                handleEdit={handleEdit}
              />
            );
          })}
      </ListGroup>
    </>
  );
};

export default SortableList;
